import 'babel-polyfill';
import React from 'react'
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import logger from 'redux-logger';
import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux';
import registerServiceWorker from './config/serviceWorker/registerServiceWorker';
import allReducers from './config/allReducers';
import createHistory from 'history/createBrowserHistory';
import { connect} from 'react-redux';
import { Route, Switch } from 'react-router';
import history from './config/history/history';
import { withRouter } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom'

// Core Layout
import CoreLayout from './components/CoreLayout';

// Service Worker
registerServiceWorker();

// Create Store
const store = createStore(
    allReducers,
    applyMiddleware(routerMiddleware(history)),
);

// App enclosed with location
const App = connect(state => ({
  location: state.location,
}))(CoreLayout)

// Remove Blocked App for React-Router Component Reload
const NonBlockApp = withRouter(App);

// Render Root Component
ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <NonBlockApp />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js